module.exports = __webpack_public_path__ + "img/tarj1-4.4633eb88.svg";